import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { updateProductOptions, getPictureDescription } from '@/services/productDetail';
import { upload } from '@/services/common';
import draggable from 'vuedraggable';
import cropperModal from './cropperModal.vue';
import TinymceEditor from '@/components/tinymce';
import FooterToolBar from '@/components/tool/FooterToolBar';
import fanyiPic from '@/assets/fanyi.png';
export default {
  name: 'pictureDescription',
  i18n: require('../i18n-productDetail'),
  components: {
    draggable: draggable,
    cropperModal: cropperModal,
    TinymceEditor: TinymceEditor,
    FooterToolBar: FooterToolBar
  },
  props: {
    productId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      //				fanyiPic,
      queryLoading: false,
      tabKey: 0,
      dataForm: {
        id: '',
        specImageList: [],
        host: ""
      },
      previewVisible: false,
      previewImage: '',
      languageList: [],
      initDataForm: {
        id: '',
        specImageList: [],
        host: ""
      },
      uploadLimit: 5,
      Uploading: false,
      uploadIndex: undefined
    };
  },
  mounted: function mounted() {
    var self = this;
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.loadData();
  },
  methods: {
    //			getshowDescFYStatus(data) {
    //				let self = this;
    //				let dataListClone = self.dataForm.dataList;
    //				for(let one of dataListClone) {
    //					one.showDescFY = true;
    //				}
    //
    //				console.log(data)
    //
    //			},
    showFYBtn: function showFYBtn(obj) {
      var self = this;
      /* let dataListClone = self.dataForm.dataList;
      for (let item of dataListClone) {
      	for (let item2 of item.list) {
      		item2.showFY = false;
      	}
      }
      obj.showFY = true; */
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      console.log(111);
      var formData = new FormData();
      console.log(blobInfo);
      // formData.type= 6;
      formData.append('type', 6);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        }
      });
    },
    //富文本反转义html
    escape2Html: function escape2Html(str) {
      var arrEntities = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'amp': '&',
        'quot': '"'
      };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
      });
    },
    loadData: function loadData() {
      //初始化数据
      var self = this;
      getPictureDescription(self.productId).then(function (res) {
        if (res.data.code == 200) {
          self.pictureDescription = res.data.data;
          var pictureDescription = res.data.data;
          var dataList = [];
          self.languageList.forEach(function (item) {
            var objDetail = {};
            objDetail.langId = item.langId;
            objDetail.languageName = item.langName;
            //初始化 list  list为空时数据库中不插入，需要初始化
            objDetail.desc = "";
            objDetail.showFY = false;
            // pictureDescription.descList.forEach(item2 => {
            // 		if (item.langId == item2.langId){
            // 			objDetail.desc= self.escape2Html(item2.desc);
            // 		}
            // });
            dataList.push(objDetail);
          });
          // self.dataForm.descList = dataList;
          self.dataForm.host = pictureDescription.host;
          self.dataForm.id = self.productId;
          self.dataForm.specFlag = pictureDescription.specFlag;
          self.dataForm.specImageList = pictureDescription.specImageList;
          self.initDataForm = _.cloneDeep(self.dataForm);
          self.uploadLimit = pictureDescription.uploadLimit;
        }
      });
    },
    // 选择文件后且beforeUpload返回为true后会调用这个方法
    handleUploadChange: function handleUploadChange(_ref, index) {
      var _this = this;
      var action = _ref.action,
        file = _ref.file,
        onSuccess = _ref.onSuccess,
        onError = _ref.onError,
        onProgress = _ref.onProgress;
      this.uploadIndex = index;
      console.log({
        action: action,
        file: file,
        onSuccess: onSuccess,
        onError: onError,
        onProgress: onProgress
      }, index, '111111111111111');
      // 这个回调函数的参数是个File对象,所以要用FileReader将对象转换成 data-uri (base64) 对象,才能给vue-cropper
      // var reader = new FileReader();
      // const _this = this;
      // 当文件处理完成的回调函数
      // reader.onload = function(e) {
      // e.target.result 该属性表示目标对象的DataURL
      // 然后调用cropperModal的edit方法使得对话框可见
      // console.log(_this.$refs[`cropperModal${index}`])
      // 	_this.$refs[`cropperModal${index}`][0].edit(e.target.result);
      // };
      // 记录原始的文件名字,用于DataURL(base64)转成file对象,不转就可以不用

      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        _this.tmpImgName = file.name;
        _this.handleOK(fileReader.result, index);
      };

      // if (info.file.status === 'done') {
      //
      // 	this.tmpImgName = info.file.name;
      //
      // 	const reader = new FileReader();
      // 	reader.addEventListener('load', () => {
      //
      // 	});
      // 	reader.readAsDataURL(info.file.originFileObj);
      // }

      // 文件处理 file=>base64
      // reader.readAsDataURL(info.file.originFileObj);
    },
    // 对文件格式校验(ant-upload选择文件框是所有类型的)
    beforeUpload: function beforeUpload(file) {
      //				var fileType = file.type;
      ////				console.log(file.type);
      //				if(fileType.indexOf('image') < 0) {
      //					this.$message.warning('请上传图片');
      //					return false;
      //				}

      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt;
    },
    // 然后这里可以调用api请求上传图片
    handleOK: function handleOK(data, index) {
      var _this2 = this;
      var file = this.dataURLtoFile(data, this.tmpImgName);
      console.log(file);
      // ....省略api请求 2种格式的对象都拿到了 怎么请求不用说了吧
      var formData = new FormData();
      formData.append('type', 1);
      formData.append('file', file);
      console.log(formData);
      upload(formData).then(function (result) {
        console.log(result);
        if (result.data.code == 200) {
          //追加列表
          _this2.Uploading = false;
          _this2.dataForm.specImageList[index].imageList.push({
            status: 'done',
            productImage: result.data.data.uploadfilepath,
            productIndex: _this2.dataForm.specImageList[index].imageList.length + 1
          });
          //						let rs = result.data.data;
        }
      });
    },
    // 将base64转换为文件 百度随便找的 看需求使用
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      console.log(mime);
      return new File([u8arr], filename, {
        type: mime
      });
    },
    handlePreview: function handlePreview(file) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log(file.preview);
              if (!(!file.productImage && !file.preview)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getBase64(file.originFileObj);
            case 1:
              file.preview = _context.v;
            case 2:
              _this3.previewImage = _this3.dataForm.host + file.productImage || file.preview;
              _this3.previewVisible = true;
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 看到multiple了吗，后面的数字为改组件允许最多传多少张，如果不限制图片张数的话，写999就可以了
    handleCancel: function handleCancel() {
      this.previewVisible = false;
    },
    handleChange: function handleChange(info) {
      if (info.file.status === 'uploading') {
        this.Uploading = true;
        return;
      }
    },
    handleDelete: function handleDelete(data, image, index) {
      console.log(data, image, index);
      var self = this;
      var newData = self.dataForm.specImageList[index].imageList.filter(function (item) {
        return item.productImage !== image.productImage;
      });
      self.dataForm.specImageList[index].imageList = newData;
    },
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var self = this;
      self.tabKey = activeKey;
      // let dataListClone = self.dataForm.descList;
      /* for(let one of dataListClone) {
      	one.showDescFY = false;
      	console.log(one.showDescFY)
      } */
    },
    //			showDescFY(obj) {
    //				obj.showDescFY = true;
    //			},
    /* 初始化输入项 */
    resetdatavalue: function resetdatavalue() {
      var self = this;
      // self.datavalue =  _.cloneDeep(self.inidatavalue);
    },
    /* 确定添加 */save: function save() {
      var _this4 = this;
      var self = this;
      if (self.dataForm.specImageList[0].imageList <= 0) {
        if (self.dataForm.specFlag != 2) {
          //一维规格
          var one = _.find(self.dataForm.specImageList, function (specImage) {
            return specImage.imageList.length == 0 && specImage.specId > 0;
          });
          if (one) {
            self.$message.error(this.$t('productDetail.publicPicOrAllPic'));
            return;
          }
        } else {
          self.$message.error(this.$t('productDetail.productPictureError'));
          return;
        }
      }

      // 修改图片排序index
      self.dataForm.specImageList.forEach(function (item, index) {
        item.imageList.forEach(function (item2, index2) {
          item2.productIndex = index2 + 1;
        });
      });
      self.queryLoading = true;
      updateProductOptions(self.dataForm).then(function (res) {
        if (res.data.code == 200) {
          self.queryLoading = false;
          self.initDataForm = _.cloneDeep(self.dataForm);
          self.$message.success(_this4.$t('public.saveSuccessfully'));
        } else {
          self.queryLoading = false;
        }
      }).finally(function () {
        self.queryLoading = false;
      });
    },
    check: function check() {
      if (JSON.stringify(this.initDataForm) != JSON.stringify(this.dataForm)) {
        return false;
      } else {
        return true;
      }
    }
  }
};